(function () {
  var desktop = window.matchMedia('(min-width: 992px)');

  function loadProductByHandle(handle) {
    return fetch('/products/' + handle + '.js').then(function (response) {
      return response.json();
    });
  }

  function closeSizeSelect(select) {
    if (!select) return;

    select.classList.remove('is-open');

    var toggle = select.querySelector('[data-select-toggle]');

    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  }

  function closeAllSizeSelects(exceptSelect) {
    document.querySelectorAll('.product-card__select.is-open').forEach(function (el) {
      if (el !== exceptSelect) closeSizeSelect(el);
    });
  }

  function closeCardControls(card) {
    var controls = card.querySelector('.product-card__controls');
    var quickAddBtn = card.querySelector('.product-card__quick-add');

    if (controls) controls.classList.remove('is-open');
    if (quickAddBtn) quickAddBtn.setAttribute('aria-expanded', 'false');

    card.classList.remove('is-active');
    closeSizeSelect(card.querySelector('.product-card__select'));
  }

  function closeAllCardControls(exceptCard) {
    document.querySelectorAll('.product-card__controls.is-open').forEach(function (el) {
      var card = el.closest('.product-card');

      if (card && card !== exceptCard) closeCardControls(card);
    });
  }

  function initProductCard(card) {
    var controls = card.querySelector('.product-card__controls');

    if (!controls || card.dataset.cardReady === 'true') return;

    var form = controls.querySelector('.js-product-form');
    var jsonScript = controls.querySelector('[data-variants]');

    if (!form || !jsonScript) return;

    card.dataset.cardReady = 'true';

    var variants = JSON.parse(jsonScript.textContent);
    var quickAddBtn = card.querySelector('.product-card__quick-add');
    var variantIdInput = form.querySelector('.js-variant-id');
    var addToCartBtn = form.querySelector('.product-card__add-to-cart');

    /* ---- colours ---- */

    var colorOptions = Array.prototype.slice.call(form.querySelectorAll('.product-card__color-option'));
    var colorLabelEl = form.querySelector('.js-selected-color-label');
    var activeColorOption = form.querySelector('.product-card__color-option.is-active');
    var hasColorOptions = colorOptions.length > 0;
    var selectedColor = activeColorOption ? activeColorOption.dataset.colorValue || '' : '';

    function setColorLabel(label) {
      if (colorLabelEl) colorLabelEl.textContent = label || '';
    }

    if (colorLabelEl && !colorLabelEl.textContent.trim() && activeColorOption) {
      setColorLabel(activeColorOption.dataset.colorLabel);
    }

    /* ---- quantity (desktop only, hidden by CSS below 992px) ---- */

    var quantityWrapper = form.querySelector('.product-card__quantity');
    var quantityInput = form.querySelector('.js-quantity');

    function setQuantityEnabled(enabled) {
      if (!quantityWrapper) return;

      quantityWrapper.classList.toggle('is-disabled', !enabled);
      quantityWrapper.querySelectorAll('.product-card__quantity-btn').forEach(function (btn) {
        btn.disabled = !enabled;
      });
    }

    function resetQuantity() {
      if (quantityInput) quantityInput.value = 1;
    }

    if (quantityWrapper) {
      quantityWrapper.addEventListener('click', function (event) {
        var btn = event.target.closest('[data-quantity]');

        if (!btn) return;

        var step = btn.dataset.quantity === 'up' ? 1 : -1;

        quantityInput.value = Math.max(1, (parseInt(quantityInput.value, 10) || 1) + step);
      });
    }

    /* ---- size dropdown ---- */

    var sizeSelect = form.querySelector('.product-card__select');
    var sizeToggle = form.querySelector('[data-select-toggle]');
    var sizePanel = form.querySelector('[data-select-panel]');
    var sizeValueEl = form.querySelector('.product-card__select-value');
    var sizeLabelEl = form.querySelector('.js-selected-size-label');
    var sizePlaceholder = sizeValueEl ? sizeValueEl.dataset.placeholder || '' : '';
    var optionInputs = Array.prototype.slice.call(form.querySelectorAll('.js-option'));
    var hasSizeOptions = optionInputs.length > 0;

    function getSelectedSize() {
      for (var i = 0; i < optionInputs.length; i++) {
        if (optionInputs[i].checked) return optionInputs[i].value;
      }

      return '';
    }

    function setSizeLabel(label) {
      if (sizeLabelEl) sizeLabelEl.textContent = label || '';

      if (!sizeValueEl) return;

      sizeValueEl.textContent = label || sizePlaceholder;
      sizeValueEl.classList.toggle('is-placeholder', !label);
    }

    if (sizeToggle) {
      sizeToggle.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        if (sizeSelect.classList.contains('is-open')) {
          closeSizeSelect(sizeSelect);
        } else {
          closeAllSizeSelects(sizeSelect);
          sizeSelect.classList.add('is-open');
          sizeToggle.setAttribute('aria-expanded', 'true');
        }
      });
    }

    /* ---- controls panel (pop-up on desktop, always open on mobile) ---- */

    if (quickAddBtn) {
      quickAddBtn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        if (controls.classList.contains('is-open')) {
          closeCardControls(card);
          return;
        }

        closeAllCardControls(card);

        controls.classList.add('is-open');
        card.classList.add('is-active');
        quickAddBtn.setAttribute('aria-expanded', 'true');

        resetQuantity();
        updateAddToCartState();
      });
    }

    controls.querySelectorAll('[data-controls-close]').forEach(function (el) {
      el.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        closeCardControls(card);
      });
    });

    /* ---- variant state ---- */

    function updateAddToCartState() {
      if (!addToCartBtn) return;

      var selectedSize = getSelectedSize();
      var ready = (!hasColorOptions || Boolean(selectedColor)) && (!hasSizeOptions || Boolean(selectedSize));

      setSizeLabel(selectedSize);
      setQuantityEnabled(ready);

      addToCartBtn.disabled = !ready;
    }

    function updateVariantId() {
      var selectedOptions = [];

      optionInputs.forEach(function (input) {
        if (input.checked) {
          selectedOptions.push({
            value: input.value,
            position: Number(input.dataset.optionPosition)
          });
        }
      });

      var selectedVariant = variants.find(function (variant) {
        return selectedOptions.every(function (option) {
          return variant.options[option.position] === option.value;
        });
      });

      if (selectedVariant) variantIdInput.value = selectedVariant.id;

      updateAddToCartState();
    }

    optionInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        updateVariantId();
        closeSizeSelect(sizeSelect);
      });
    });

    function updateSizeOptions(newProduct) {
      var sizeOptionIndex = newProduct.options.findIndex(function (opt) {
        var name = opt.name || opt;
        return name.toLowerCase().indexOf('size') !== -1;
      });

      if (sizeOptionIndex === -1 || !sizePanel) return;

      var valuesMap = {};

      newProduct.variants.forEach(function (variant) {
        var value = variant.options[sizeOptionIndex];

        if (!valuesMap[value]) valuesMap[value] = false;
        if (variant.available) valuesMap[value] = true;
      });

      sizePanel.querySelectorAll('label').forEach(function (label) {
        var input = label.querySelector('input');

        if (!input) return;

        var available = valuesMap[input.value] || false;

        input.disabled = !available;
        input.checked = false;

        label.classList.toggle('product-card-option-active', available);
        label.classList.toggle('product-card-option-disabled', !available);
      });

      var firstAvailable = newProduct.variants.find(function (v) {
        return v.available;
      });

      variantIdInput.value = firstAvailable ? firstAvailable.id : newProduct.variants[0].id;

      closeSizeSelect(sizeSelect);
      setSizeLabel('');
    }

    function updateCardImages(newProduct) {
      var primaryUrl = newProduct.images[0];
      var secondaryUrl = newProduct.images[1];
      var primaryImg = card.querySelector('.product-card__image');
      var secondaryImg = card.querySelector('.product-card__image-secondary');
      var cardLink = card.querySelector('.product-card__link');

      function sized(url, width) {
        return url.replace(/(\.[^.]+)$/, '_' + width + 'x$1');
      }

      function setImgSrc(img, url) {
        img.src = 'https:' + sized(url, 600);
        img.srcset = 'https:' + sized(url, 600) + ' 600w, https:' + sized(url, 1200) + ' 1200w';
      }

      if (primaryImg && primaryUrl) {
        primaryImg.classList.add('is-loading-image');
        setImgSrc(primaryImg, primaryUrl);
        primaryImg.onload = function () {
          primaryImg.classList.remove('is-loading-image');
        };
        primaryImg.onerror = function () {
          primaryImg.classList.remove('is-loading-image');
        };
      }

      if (secondaryImg) {
        var url = secondaryUrl || primaryUrl;
        if (url) setImgSrc(secondaryImg, url);
      }

      if (cardLink && cardLink.getAttribute('href') !== newProduct.url) {
        cardLink.setAttribute('href', newProduct.url);
      }
    }

    colorOptions.forEach(function (colorOption) {
      colorOption.addEventListener('click', function () {
        colorOptions.forEach(function (c) {
          c.classList.remove('is-active');
        });

        this.classList.add('is-active');
        selectedColor = this.dataset.colorValue || '';
        setColorLabel(this.dataset.colorLabel);
        updateAddToCartState();

        var handle = this.dataset.productHandle;

        if (!handle) return;

        loadProductByHandle(handle)
          .then(function (newProduct) {
            variants = newProduct.variants;
            form.dataset.productId = newProduct.id;

            updateCardImages(newProduct);
            updateSizeOptions(newProduct);
          })
          .catch(function (error) {
            console.error('Error loading color variant:', error);
          })
          .then(function () {
            updateAddToCartState();
          });
      });
    });

    /* ---- add to cart ---- */

    form.addEventListener('submit', async function (event) {
      var ready = (!hasColorOptions || Boolean(selectedColor)) && (!hasSizeOptions || Boolean(getSelectedSize()));

      if (!ready) {
        event.preventDefault();
        updateAddToCartState();
        return;
      }

      /* The stepper is invisible below 992px, so a value carried over from a
         wider viewport would silently add more than one item. */
      if (!desktop.matches) resetQuantity();

      if (theme.settings.afterAddToCart !== 'drawer') return;

      event.preventDefault();

      if (addToCartBtn.getAttribute('aria-disabled') === 'true') return;

      addToCartBtn.setAttribute('aria-disabled', 'true');
      addToCartBtn.classList.add('is-loading');

      var formData = new FormData(form);
      var sectionsToUpdate = ['page-header', 'cart-drawer']
        .map(function (sel) {
          return document.querySelector(sel);
        })
        .filter(Boolean);

      formData.append('sections_url', window.location.pathname);
      formData.append(
        'sections',
        sectionsToUpdate
          .map(function (el) {
            return el.dataset.sectionId;
          })
          .join(',')
      );

      try {
        var response = await fetch(theme.routes.cartAdd, {
          method: 'POST',
          headers: {
            Accept: 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: formData
        });
        var data = await response.json();

        if (!response.ok) throw new Error(response.status);

        if (document.querySelector('.template-cart')) {
          var cartForm = document.querySelector('cart-form');

          if (cartForm && cartForm.enableAjaxUpdate) cartForm.refresh();
        } else {
          if (data.sections) {
            sectionsToUpdate.forEach(function (el) {
              el.updateFromCartChange(data.sections[el.dataset.sectionId]);
            });
          }

          document.querySelector('.js-cart-drawer')?.open();
        }

        this.dispatchEvent(
          new CustomEvent('on:cart:add', {
            bubbles: true,
            detail: { variantId: data.variant_id }
          })
        );

        addToCartBtn.classList.add('is-success');
      } catch (error) {
        console.error('Error adding to cart:', error);

        this.dispatchEvent(
          new CustomEvent('on:cart:error', {
            bubbles: true,
            detail: { error: form.querySelector('.js-error-msg')?.textContent ?? '' }
          })
        );
      } finally {
        addToCartBtn.removeAttribute('aria-disabled');

        setTimeout(function () {
          addToCartBtn.classList.remove('is-loading');
          addToCartBtn.classList.remove('is-success');
        }, 2000);

        if (desktop.matches) closeCardControls(card);
      }
    });

    updateAddToCartState();
  }

  function init() {
    document.querySelectorAll('.product-card').forEach(initProductCard);
  }

  function watchForNewCards() {
    var scheduled = false;

    new MutationObserver(function (mutations) {
      if (scheduled) return;

      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length === 0) continue;

        scheduled = true;
        requestAnimationFrame(function () {
          scheduled = false;
          init();
        });
        return;
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    closeAllSizeSelects(null);
    closeAllCardControls(null);
  });

  document.addEventListener('click', function (event) {
    var target = event.target;

    if (!target || typeof target.closest !== 'function') return;

    if (!target.closest('.product-card__select')) closeAllSizeSelects(null);

    if (desktop.matches && !target.closest('.product-card')) closeAllCardControls(null);
  });

  function start() {
    init();
    watchForNewCards();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
